import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeSanitize from "rehype-sanitize";
import { api } from "../lib/api";
import PageSEO from "../components/SEO";

const TITLES = {
  aviso_legal: "Aviso legal",
  privacidad: "Política de privacidad",
  cookies: "Política de cookies",
  terminos_y_condiciones: "Términos y condiciones",
};

/** Public legal page renderer.
 *
 * Phase 25 — enables GFM tables (needed for the cookies list) and sanitizes
 * HTML injected via markdown so the admin editor can't accidentally break the
 * storefront. Tables use a slim `<table>` style to match the MercaGo look.
 */
export default function LegalPage() {
  const { slug } = useParams();
  const [md, setMd] = useState(null);
  const [notFound, setNotFound] = useState(false);
  useEffect(() => {
    setMd(null);
    setNotFound(false);
    api
      .get(`/legal/pages/${slug}`)
      .then((r) => setMd(r.data?.markdown || ""))
      .catch(() => setNotFound(true));
  }, [slug]);

  return (
    <main
      data-testid="public-legal-page"
      className="mx-auto max-w-3xl px-4 sm:px-6 py-10"
    >
      <PageSEO
        title={TITLES[slug] || "Página legal"}
        description={`${TITLES[slug] || "Página legal"} de MercaGo — información legal sobre nuestro servicio de envío a los campamentos saharauis.`}
        canonical={`https://mercago.one/legal/${slug}`}
      />
      <h1 className="text-3xl font-black tracking-tight mb-6">
        {TITLES[slug] || "Página legal"}
      </h1>
      {notFound ? (
        <p className="text-neutral-500">Esta página aún no está publicada.</p>
      ) : md === null ? (
        <div className="h-24 rounded-xl bg-neutral-100 animate-pulse" />
      ) : (
        <div
          data-testid="public-legal-content"
          className="prose prose-sm sm:prose max-w-none prose-headings:font-black prose-h2:mt-8 prose-h2:mb-3 prose-h3:mt-6 prose-a:text-[#00953B] prose-a:no-underline hover:prose-a:underline prose-table:text-sm prose-th:bg-[#F1FAF3] prose-th:font-semibold prose-th:px-3 prose-th:py-2 prose-td:px-3 prose-td:py-2 prose-th:border prose-th:border-neutral-200 prose-td:border prose-td:border-neutral-200"
        >
          <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            rehypePlugins={[rehypeSanitize]}
          >
            {md}
          </ReactMarkdown>
        </div>
      )}
    </main>
  );
}
